module.exports = __webpack_public_path__ + "static/media/downloaded-esim-android.932ac09d.webp";